
import React, { useState } from 'react';
import { Menu, Search, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ProfileDropdown from '@/components/layout/ProfileDropdown';
import { HeaderMobileMenu } from './HeaderMobileMenu';
import { HeaderActions } from './HeaderActions';
import GlobalSearch from '@/components/search/GlobalSearch';
import { useUnreadMessages } from '@/hooks/useUnreadMessages';
import { useNotificationsUnified } from '@/hooks/useNotificationsUnified';

export const HeaderMobilePage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { count: unreadCount, isLoading: isLoadingMessages } = useUnreadMessages();
  const { unreadCount: notificationCount } = useNotificationsUnified({ limit: 5 });

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleSearch = () => setIsSearchOpen(!isSearchOpen);

  const totalNotifications = unreadCount + notificationCount;

  return (
    <>
      {/* Header with two buttons on left, empty center, two buttons on right */}
      <div className="flex justify-between items-center h-16 desktop:hidden w-full px-0">
        {/* Left section: burger and search */}
        <div className="flex items-center space-x-3">
          <Button variant="ghost" onClick={toggleMenu} className="h-12 w-12 p-0 flex items-center justify-center">
            <Menu className="h-5 w-5" />
          </Button>
          
          <div className={`flex items-center ${isSearchOpen ? 'absolute left-0 right-0 px-4 z-10' : ''}`}>
            {!isSearchOpen ? (
              <Button variant="outline" onClick={toggleSearch} className="h-12 w-12 p-0 flex items-center justify-center rounded-xl bg-white border border-gray-200">
                <Search className="h-5 w-5" />
              </Button>
            ) : (
              <div className="w-full bg-white py-2 relative">
                <GlobalSearch 
                  placeholder="Поиск..." 
                  isMobile={true}
                  className="w-full"
                />
                <Button 
                  type="button" 
                  variant="ghost" 
                  size="icon" 
                  onClick={toggleSearch} 
                  className="absolute right-1 top-1/2 transform -translate-y-1/2 h-10 w-10"
                >
                  <X className="h-4 w-4" />
                </Button>
              </div>
            )}
          </div>
        </div>
        
        {/* Empty center space */}
        <div className="flex-1"></div>
        
        {/* Right section: create button and profile */}
        <div className="flex items-center space-x-3">
          {/* Create button */}
          <div className="flex items-center">
            <HeaderActions isMobile={true} />
          </div>
          
          {/* Profile button */}
          <div className="flex items-center">
            <div className="relative">
              {/* Show notification badge only if there are unread messages or notifications */}
              {!isLoadingMessages && totalNotifications > 0 && (
                <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center z-10">
                  {totalNotifications > 99 ? '99+' : totalNotifications}
                </div>
              )}
              <ProfileDropdown className="h-12 w-12 p-0 rounded-xl border-gray-200 bg-gray-100 flex items-center justify-center" />
            </div>
          </div>
        </div>
      </div>
      
      {/* Мобильное меню */}
      {isMenuOpen && <HeaderMobileMenu onClose={toggleMenu} />}
    </>
  );
};
